import * as tslib_1 from "tslib";
import selectFirstRow from './selectFirstRow';
import selectRowInDirection from './selectRowInDirection';
import { SelectionDirection } from 'owa-mail-list-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/**
 * Select the next row
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export default function selectNextRowInternal(tableView, mailListItemSelectionSource) {
    var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
    if (selectedRowKeys.length > 0) {
        selectRowInDirection(tableView, SelectionDirection.Next, isMailFeatureEnabled('tri-selectionRefactor')
            ? tableView.selectionAnchorRowKey
            : selectedRowKeys[0], mailListItemSelectionSource);
    }
    else if (selectedRowKeys.length == 0) {
        // Select the first item when there is no selection
        selectFirstRow(tableView, mailListItemSelectionSource);
    }
}
//# sourceMappingURL=selectNextRowInternal.js.map